import React from 'react'
import Select from 'react-select'

function CustomSelect({ style, label_fr,label_ar, options, onChange, defaultValue, isMulti }) {
  return <div style={style}>
    <h2>{label_fr}</h2>
    <h2>{label_ar}</h2>
    <Select menuPlacement='auto' menuColor='black' backgroundColor='white' className="CustomSelect" options={options} onChange={onChange} defaultValue={defaultValue} />
  </div>
}

export default CustomSelect;

